// PHASE-2.03 START
import React from 'react';
import { Button } from '@/components/ui/Button';
import { cn } from '@/lib/utils';
import { BookmarkIcon } from '@heroicons/react/24/outline';

type Props = {
  query: string;
  setQuery: (q: string) => void;
  client: string | 'all';
  setClient: (c: string | 'all') => void;
  pinnedOnly: boolean;
  setPinnedOnly: (p: boolean) => void;
  clients?: string[];
};

export function HistoryToolbar({ query, setQuery, client, setClient, pinnedOnly, setPinnedOnly, clients = [] }: Props) {
  const inputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === '/') {
        e.preventDefault();
        inputRef.current?.focus();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  return (
    <div className="flex flex-col gap-2 w-full">
      {/* Search */}
      <label className="relative w-full">
        <span className="sr-only">Search history</span>
        <input
          ref={inputRef}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search (/)"
          className="w-full h-10 rounded-xl bg-background/50 backdrop-blur-sm border border-border/40 px-3 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 focus-visible:border-primary/60 transition-all placeholder:text-muted-foreground/60"
        />
      </label>
      {/* Second row: controls */}
      <div className="flex items-center gap-2 w-full overflow-hidden">
        {/* Client selector */}
        <label className="inline-flex items-center gap-2 h-10 px-2 rounded-xl bg-background/50 backdrop-blur-sm border border-border/40 flex-1 min-w-0">
          <span className="text-xs text-muted-foreground/70 shrink-0">Client</span>
          <select
            value={client}
            onChange={(e) => setClient(e.target.value as any)}
            className="h-9 w-full min-w-0 rounded-lg bg-transparent text-sm focus-visible:outline-none"
          >
            <option value="all">All</option>
            {clients.map(c => (
              <option key={c} value={c}>{c}</option>
            ))}
          </select>
        </label>
        {/* Pinned toggle */}
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setPinnedOnly(!pinnedOnly)}
          className={cn(
            'shrink-0 h-10 px-3 rounded-xl border border-border/40',
            pinnedOnly ? 'bg-primary/10 text-primary border-primary/30' : 'bg-background/50 text-muted-foreground'
          )}
          title={pinnedOnly ? 'Show all' : 'Show pinned only'}
        >
          <BookmarkIcon className={cn('h-4 w-4', pinnedOnly && 'text-primary')} />
        </Button>
      </div>
    </div>
  );
}
// PHASE-2.03 END
